import React, { useCallback, createRef, useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryGridAr from "../components/EntryGridAr";
import EntrySetting from "../components/EntrySetting";
import DataTree from "../components/DataTree";
import Headline from "../components/Headline";
import GridPanelControl from "../components/GridPanelControl";
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import {
    isEnabled, isEmpty, getformid, getcontroller, getsubkey, CellType, getWindowDimensions, setglobaldata, customTarget,
    DicVal, getglobaldata, DeepCopy, initializedata, RandomKey, Savestorage, Getstorage, Floor, NumConv, Round
} from '../modules/appLibrary';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, setgridlist, entrytriggercall, reports, gridmaximize} from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup } from '../modules/toolpanelstore';
import EntryBase from "../components/EntryBase";

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));


export const Colourway = props => {
    const GridPanelStorageKey = "Colourway_GridPanel";   //GridPanel最大化フラグ保存キー
    const panelsdef = [];
    const G_id = { BASE: "0", ROW1: "1", ROW2: "2", ROW3: "3", TOTAL1: "T1", TOTAL2: "T2", TOTAL3: "T3", NB: "nb", PL: "pl" };
    const primarykeys = ["d_cw_no", "d_cwraw_no"];
    const formid = getformid("Colourway", props.location.search);
    const controller = getcontroller("Colourway", props.location.search);
    const subkey = getsubkey(props.location.search);


    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);

    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const locationstate = useRef(null);    //遷移State


    const formstatus = useSelector(state => state.form.status);
    const formlock = useSelector(state => state.form.entryformlock);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [update, setUpdata] = useState(false);
    const [masterdetail, setmasterdetail] = useState(true);     //SKU展開
    const [initshow, setinitshow] = useState(true);             //明細初期表示
    const [onetomany, setonetomany] = useState(false);          //コード１に対し配色多
    const [detailCellRendererParams, setdetailCellRendererParams] = useState(null);
    const gridlist = useSelector(state => state.form.gridlist);

    const dispatch = useDispatch();
    const CELLTYPE = CellType();
    const search = useLocation().search;
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const scrollRef = useRef(null);
    const reportsRef = useRef(null);
    const GridPanelRef = useRef(null);      //最大化状態
    //変更確認用
    const editcode = useRef("");
    const setcolor = useRef(null);          //ダイドー仕様
    const setsize = useRef(null);           //ダイドー仕様

    const gridapiRefs = useRef([]);
    const gridcolapiRefs = useRef([]);
    const griddataRefs = useRef([]);
    const gridcolRefs = useRef([]);

    //データ
    const entrydataRef = useRef(null);
    const skuqtyRef = useRef(null);

    function SetGridData(panel, data) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        griddataRefs.current[gidx].current = data;
    }
    function GridData(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return griddataRefs.current[gidx].current;
    }
    function GridColDef(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridcolRefs.current[gidx].current;
    }
    function SetGridColDef(panel, coldef) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolRefs.current[gidx].current = coldef;
    }
    function SetGridApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridapiRefs.current[gidx].current = api;
    }
    function GridApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridapiRefs.current[gidx].current;
    }
    function SetGridColApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolapiRefs.current[gidx].current = api;
    }
    function GridColApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridcolapiRefs.current[gidx].current;
    }
    function RebuildGridColDef(id) {
        if (isEmpty(columninfo) || isEmpty(columns) || isEmpty(AGRef.current)) return null;
        let panelinfo = IdToPanel(id);
        if (isEmpty(panelinfo)) return null;
        let coldef = AGRef.current.createColDef(
            columninfo.filter(e => e.logpid === id),
            columns.filter(e => e.logpid === id),
            panelinfo.id !== G_id.PL && masterdetail
        );
        SetGridColDef(panelinfo, coldef);
        return coldef;
    }
    function EnsureGridColDef(id) {
        let panelinfo = IdToPanel(id);
        if (isEmpty(panelinfo)) return null;
        let coldef = GridColDef(panelinfo);
        if (!isEmpty(coldef)) return coldef;
        return RebuildGridColDef(id);
    }
    function RerenderProductGrids() {
        [G_id.ROW1, G_id.ROW2, G_id.ROW3].forEach(function (id) {
            if (!EmptyPanel(id)) {
                fnc.current.rerenderGrid(fnc.current.GridID(IdToPanel(id)));
            }
        });
    }

    function IdToPanel(id) {
        return gridlist.find(e => e.id === id);
    }

    const actionurl = {
        "insert": "colourway/Insert",
        "update": "colourway/Update",
        "delete": "colourway/Delete",
        "saveas": "colourway/SaveAs",
        "upload": "colourway/Upload",
    }
    const navmenu = [
        { status: "ENTRY FORM", menuid: "datatree", icon: "account_tree", label: "Data Tree" },
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "listdatatree", icon: "account_tree", label: "Data Tree" },
    ]

    //動作抑止
    const suppressaction = [
        { type: "0", action: "INSERT" }
    ];

    function rerender() {
        setUpdata(update ? false : true);
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        //ListTabを取得
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    dispatch(reports(data.reports));
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    reportsRef.current = data.reports;

                    setcolumninfo(data.colinfo);
                    setcolumns(data.columns);
                    let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
                    settextfieldsall(fields);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    fnc.current.initMaster(data.master);

                    let idx = 0;
                    let glist = [];
                    let gridmaxinit = {};
                    data.panels.filter(e => e.grid).forEach(function (panel) {
                        gridapiRefs.current[idx] = createRef();
                        gridcolapiRefs.current[idx] = createRef();
                        griddataRefs.current[idx] = createRef();
                        gridcolRefs.current[idx] = createRef();
                        glist.push({ id: panel.id, type: panel.type, index: idx });
                        gridmaxinit[fnc.current.GridID(panel)] = false;
                        idx++;
                        //合計、ヘッダGrid
                        for (let i = 0; i < 2; i++) {
                            if (i == 0 ? panel.total : panel.Header) {
                                let id = (i == 0 ? "T" : "H") + panel.id
                                let pnltype = (i == 0 ? panel.totaltype : panel.Headertype);
                                gridapiRefs.current[idx] = createRef();
                                gridcolapiRefs.current[idx] = createRef();
                                griddataRefs.current[idx] = createRef();
                                gridcolRefs.current[idx] = createRef();
                                glist.push({ id: id, type: pnltype, index: idx });
                                idx++;
                            }
                        }
                    });
                    dispatch(setgridlist(glist));

                    //パネル最大化Flag
                    var gridmax = Getstorage(corpkey, account, GridPanelStorageKey);    //保存データ
                    if (isEmpty(gridmax)) {
                        gridmax = gridmaxinit;
                    }
                    GridPanelRef.current = gridmax
                    dispatch(gridmaximize(gridmax));
                    if (data.prelayout) {   //レイアウト復元
                        RestoreLayout(data.panels, fields);
                    }

                    //遷移state取得
                    let state = props.location.state;   //history.push
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            //go back
                            state = window.history.state;
                        }
                    }
                    locationstate.current = state;
                    if (!isEmpty(state)) {
                        if ("code" in state) {
                            if (state.code === "") clearform();
                            dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
                        }
                    }
                    fnc.current.wait(false);
                }
            });
    }, [search]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setmasterdetail(menuinfo.ctrls.indexOf("CWEXPAND") === -1);     //SKU展開
        setinitshow(menuinfo.ctrls.indexOf("CWNODEF") === -1);          //明細初期表示
        setonetomany(menuinfo.ctrls.indexOf("CWMANY") !== -1);         //コード１に対し配色多
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1);     //セクションCLOSEボタン
    }, [menuinfo]);


    useEffect(() => {
        if (formstatus === "COPY FORM") {
            entrydataRef.current["d_cw_no"] = "";
            entrydataRef.current["d_cw_createac"] = "";
            entrydataRef.current["d_cw_createdate"] = "";
            entrydataRef.current["d_cw_updateac"] = "";
            entrydataRef.current["d_cw_update"] = "";
            rerender();
        }
    }, [formstatus]);

    function MenuQueryAction(action, param) {
        if (action === 'delete' && formstatus === "UPDATE") {
            if (param.tabvalue !== '0') {
                fnc.current.warnmsg("このシートのデータは削除できません");
                return false;
            }
        }
        return true;
    }

    //遷移state状態表示
    function callshow() {
        if (locationstate.current.code !== "") {
            if (customTarget(corpkey, "daidoh")) {
                Show(undefined, locationstate.current.code.slice(0, -2))
            } else {
                Show(undefined, locationstate.current.code)
            }
        } else {
            if (!isEmpty(locationstate.current.acceptno)) {
                clearform(true);
                if (locationstate.current.accepttype === "0") {
                    entrydataRef.current["d_cw_prodno"] = locationstate.current.acceptno;
                } else {
                    entrydataRef.current["d_cw_instno"] = locationstate.current.acceptno;
                }
                if (isEmpty(columninfo)) return false;    //読み込み前
                ValueChanged(locationstate.current.accepttype==="0"?"d_cw_prodno":"d_cw_instno", locationstate.current.acceptno);
            }
        }
        locationstate.current = null;   //最初の１度のみ
    }

    function onFirstDataRendered(param, panel) {
        SetGridApi(panel, param.api);
        SetGridColApi(panel, param.api);

        if (!isEmpty(locationstate.current)) {
            let call = true;
            for (let i = 0; i < gridlist.length; i++) {
                if (EmptyPanel(gridlist[i].id, gridlist[i].type)) continue;
                if (isEmpty(GridApi(gridlist[i]))) {
                    call = false; break;
                }
            }
            //遷移表示
            if (call) callshow();
        }
    }

    function Show(data, pushcode) {
        let code = "";
        if (data === undefined) {
            if (!isEmpty(pushcode)) {   //history.push
                code = pushcode;
                setedittingcode(code);
            } else {
                code = edittingcode;    //再表示
            }
        } else {
            setglobaldata("entryrowdata", data);
            if (data !== null) {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]]; break;
                    }
                }
            }
            setedittingcode(code);
        }
        if (isEmpty(columninfo)) return false;    //読み込み前
        clearform(code === "");
        //データ読み込み
        LoadData(code);
        return true;
    }

    //リストレイアウト適用
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e => e.type !== type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
    }

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    // スクロール位置を保存する
    function saveScrollPos() {
        scrollRef.current = EntrybodyRef.current.scrollTop;
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        try {
            if (scrollRef.current) EntrybodyRef.current.scrollTop = scrollRef.current;
        } catch { }
    }
    //行データ保持
    function storeRowData(panel) {
        if (panel === undefined) {
            for (let i = 0; i < gridlist.length; i++) {
                SetGridData(gridlist[i], AGRef.current.GetDatasource(GridApi(gridlist[i])));
            }
        } else {
            SetGridData(panel, AGRef.current.GetDatasource(GridApi(panel)));
        }
    }

    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.NB) panelid = 'remarkspanel' + type;
        if (isEmpty(type)) {
            type = tabletype(id);
        }
        if (panel.some(e => e.id === id && e.type === type && e.grid)) {
            panelid = fnc.current.GridID({ id: id, type: type });
        }
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }


    function MenuAction(action, finallycallback, param) {
        LayoutSaveStorage();   //現在レイアウト保持
        if (action === 'save') Save(finallycallback);
        if (action === 'delete') Delete(finallycallback);
        if (action === "clear")  clearform(true);
        if (action === 'linkfield') {
            var type = finallycallback.type;
            if (isEmpty(finallycallback.type)) {
                let col = textfields.find(e => e.columnid === finallycallback.field);
                if (col === undefined) return;
                type = col.type;
            }
            if (finallycallback.table == "d_cw") {
                let col = textfields.find(e => e.columnid === finallycallback.field);
                if (col !== undefined) {
                    let key = finallycallback.field + "_" + finallycallback.type;
                    document.getElementById(key).focus();
                    document.getElementById(key).select();
                }
                Jump(G_id.BASE, type);
                return;
            }
            let col = columninfo.find(e => e.type === type);
            if (col === undefined) return;
            let logpid = col.logpid;
            Jump(logpid);
            AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, GridApi(IdToPanel(logpid)));
        }
        if (reportsRef.current.some(e => e.id === action)) {   //帳票
            let code = [];
            if (formstatus === "ENTRY FORM") {
                code = [edittingcode];
            } else {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (primarykeys[i] in param[0]) {
                        for (let j = 0; j < param.length; j++) {
                            code.push(param[j][primarykeys[i]]);
                        }
                        break;
                    }
                }
            }
            if (code.length === 0) return;
            fnc.current.postaxios('common/Printout', { controller: controller, id: action, keys: code },
                {
                    onSuccess: function (data) {
                        let params = {
                            "excelfile": data.returnData["filename"],
                            "dnfile": data.returnData["dnfile"]
                        }
                        fnc.current.filedownload("excel/ExcelDownload", params);
                        fnc.current.wait(false);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
            return;
        }
        if (action === 'datatree') {
            DataTreeOpen(edittingcode);
        }
        if (action === 'listdatatree') {
            for (let i = 0; i < primarykeys.length; i++) {
                if (primarykeys[i] in param[0]) {
                    setedittingcode(param[0][primarykeys[i]]);
                    DataTreeOpen(param[0][primarykeys[i]]);
                    return;
                }
            }
        }
        function DataTreeOpen(code) {
            fnc.current.postaxios('colourway/GetDataTree', { "code": code, "controller": formid},
                {
                    onSuccess: function (data) {
                        fnc.current.wait(false);
                        fnc.current.datatreeopen(data.list);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
        }
    }

    function Save(finallycallback ) {
        storeRowData();
        let exist = false;
        for (let i = 0; i < gridlist.length; i++) {
            if (AGRef.current.ExistValidRow(GridData(gridlist[i]), columninfo, GridColDef(gridlist[i]))) {
                exist = true; break;
            }
        }
        if (!exist) {
            fnc.current.warnmsg("有効な登録データが存在しません");
            return;
        }
        Apply();

        function Apply() {
            if (isEmpty(entrydataRef.current)) entrydataRef.current = {};
            for (let i = 0; i < gridlist.length; i++) {
                if (gridlist[i].total) {
                    if (!isEmpty(GridData(gridlist[i]))) {
                        for (let key in GridData(gridlist[i])[0]) {
                            if (key === "rowid") continue;
                            entrydataRef.current[key] = GridData(gridlist[i])[0][key]
                        }
                    }
                }
            }

            SetPLData();    //PL行データをentrydataRefにセット
            const paramdata = {
                "controller": formid,
                "data": entrydataRef.current,
                "raw1": EmptyPanel(G_id.ROW1) ? null : GridData(IdToPanel(G_id.ROW1 )),
                "raw2": EmptyPanel(G_id.ROW2) ? null : GridData(IdToPanel(G_id.ROW2 )),
                "raw3": EmptyPanel(G_id.ROW3) ? null : GridData(IdToPanel(G_id.ROW3 )),
                "colinfo": columninfo,
                "code": edittingcode
            }
            fnc.current.postaxios(formstatus === "ENTRY FORM" ? "colourway/UpdateEntry" : "colourway/InsertEntry", paramdata,
                {
                    onSuccess: function (data) {
                        if (data.warning.length === 0) {
                            fnc.current.modify(false);
                            fnc.current.success();
                            let code = edittingcode;
                            if (formstatus === "ENTRY FORM") {
                                data.data['rowid'] = Getrowid();    //更新行キー
                                finallycallback(data.data);
                            }
                            if (formstatus !== "ENTRY FORM") {
                                entrydataRef.current['d_cw_no'] = data.request;
                                setedittingcode(data.request);
                                code = data.request;
                                dispatch(changestatus("ENTRY FORM"));
                            }
                            LoadData(code);     //再表示
                        }
                        else {
                            let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                            fnc.current.showwarndescription(msg, data.warning);
                        }
                        fnc.current.wait(false);
                    },
                    errmsg: "登録に失敗しました"
                }
            )
        }
    }

    function Delete(finallycallback) {
        const param = {
            "rowdata": [{ "rowid": edittingcode }],
            "controller": formid
        }
        fnc.current.postaxios("colourway/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(edittingcode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg(["このデータは削除できません", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "削除に失敗しました"
            }
        )
    }

    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }
    function LoadData(code) {
        if (code === "") return;
        fnc.current.postaxios('colourway/GetData', { "code": code, "colinfo": columninfo, "controller": controller },
            {
                onSuccess: function (data) {
                    try {
                        if (code !== "") {
                            fnc.current.margeMaster(data.master);
                            editcode.current = DicVal(data.data, "d_cw_instno", data.data["d_cw_prodno"]);
                            entrydataRef.current = data.data;
                            gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
                                //PL行データ
                                SetGridData(l, fnc.current.PLRowData(data.data, l.type, columninfo));
                            });

                            //製品コードに対する材料情報およびSKUの表示
                            SetProductData(data);
                            //合計表示
                            if (customTarget(corpkey, 'daidoh')) {
                                editcode.current = data.data["d_cw_attribute5"];
                                setcolor.current = JSON.stringify(data.color);
                                setsize.current = JSON.stringify(data.size);
                                SetTotal("2");  //附属固定
                            } else {
                                panel.filter(e => e.total).forEach(function (p) {
                                    let totalid = "T" + p.id;
                                    var totalcols = columninfo.filter(e => e.logpid === totalid);
                                    if (totalcols.length !== 0) {
                                        let totalfields = [];
                                        for (let i = 0; i < totalcols.length; i++) {
                                            if (totalfields.indexOf(totalcols[i].columnid) === -1)
                                                totalfields.push(totalcols[i].columnid);
                                        }
                                        let total = { rowid: "TOTAL", grip: "計" };
                                        for (let i = 0; i < totalfields.length; i++) {
                                            total[totalfields[i]] = data.data[totalfields[i]];
                                        }
                                        SetGridData(IdToPanel(totalid), [total]);
                                    }
                                });
                            }
                            rerender();
                            RerenderProductGrids();
                        }
                        fnc.current.wait(false);
                    } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                    }
                },
                onError: function (data) {
                    fnc.current.wait(false);
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                }
            }
        )
    }

    function SetPLData() {
        gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
            let column = columninfo.find(e => e.type === l.type);
            if (!isEmpty(column)) {
                entrydataRef.current[column.columnid] = fnc.current.PLTextData(GridData(l), column.columnid);
            }
        });
    }

    //入力フィールドクリア
    function clearform(newform) {
        editcode.current = "";
        entrydataRef.current = initializedata(textfieldsall, staff);
        for (let i = 0; i < gridlist.length; i++) {
            SetGridData(gridlist[i], null);
            SetGridColDef(gridlist[i], null);
        }
        if (customTarget(corpkey, "daidoh")) {
            //合計行を４行作成
            var data = [{ rowid: "T1", grip: "A計" }, { rowid: "T2", grip: "B計" }, { rowid: "T3", grip: "C計" }, { rowid: "T4", grip: "D計" }]
            SetGridData(IdToPanel(G_id.TOTAL2), data);
        }
        fnc.current.modify(false);

        if (isEnabled(newform)) {
            //SQL初期値セット
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
                {
                    onSuccess: function (data) {
                        for (let key in data.returnData) {
                            var col = textfieldsall.find(e => e.columnid === key);
                            if (!isEmpty(col)) col.initvalue = data.returnData[key];
                        }
                        entrydataRef.current = initializedata(textfieldsall, staff);
                        rerender();
                    },
                }, true
            )
        }

    }

    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }
    //レイアウト保持
    function LayoutSaveStorage() {
        //列情報保存
        for (let i = 0; i < gridlist.length; i++) {
            AGRef.current.SaveColState(fnc.current.statusKey(gridlist[i].id, gridlist[i].type, formid), EmptyPanel(gridlist[i].id) ? null : GridColApi({ id: gridlist[i].id, type: gridlist[i].type }));
        }
        //基本情報保存
        Savestorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
    }

    //レイアウト登録
    function SaveLayout(layoutid) {
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            if (panel[p].id === G_id.BASE) {
                let fds = textfields.filter(x => !x.hide);
                for (let f = 0; f < fds.length; f++) {
                    coldef.push({
                        headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                        type: fds[f].type
                    });
                }
            } else {
                cols = AGRef.current.GetshownColDef(GridColApi(IdToPanel( panel[p].id )));
                cols = cols.filter(e => e.field.indexOf("__") === -1)
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id);
                coldef.push(col);
            }
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    //列情報初期化
                    var coldef = AGRef.current.createColDef(columninfo.filter(e => e.logpid === G_id.ROW1), data.columns.filter(e => e.logpid === G_id.ROW1), true);
                    var p = IdToPanel(G_id.ROW1);
                    if (GridColDef(p) !== null) {
                        //読み込まれているカラー、サイズを付加
                        SetGridColDef(p, [...coldef, ...GridColDef(p).filter(e => e.field.indexOf("__") !== -1)]);
                    }
                    coldef = AGRef.current.createColDef(columninfo.filter(e => e.logpid === G_id.ROW2), data.columns.filter(e => e.logpid === G_id.ROW2), true);
                    p = IdToPanel(G_id.ROW2);
                    if (GridColDef(p) !== null) {
                        SetGridColDef(p, [...coldef, ...GridColDef(p).filter(e => e.field.indexOf("__") !== -1)]);
                    }
                    coldef = AGRef.current.createColDef(columninfo.filter(e => e.logpid === G_id.ROW3), data.columns.filter(e => e.logpid === G_id.ROW3), true);
                    p = IdToPanel(G_id.ROW3);
                    if (GridColDef(p) !== null) {
                        SetGridColDef(p, [...coldef, ...GridColDef(p).filter(e => e.field.indexOf("__") !== -1)]);
                    }
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }
   //リスト編集セル制御
    function ListlockCell(params, edit, status, tabvalue) {
        if (status === "INSERT") {
            //自テーブル以外編集不可
            if (tabvalue !== params.colDef.colinfo.type) return false;
        }
        return edit;
    }

    //パネル別列情報取得
    function tabletype(id) {
        if (id.substr(0, 1) === "T") {  //Total
            if (isEmpty(columninfo)) return "";
            let col = columninfo.find(e => e.logpid === id);
            if (isEmpty(col)) return '';
            return col.type;
        } else {
            let pnl = panel.find(e => e.id === id);
            if (isEmpty(pnl)) return '';
            return pnl.type;
        }
    }
    //Basic Data Change
    function ValueChanged(id, value) {
        if (id === "d_cw_prodno" || id === "d_cw_instno") {   //製品コード
            if (editcode.current === value) return;
            if (isEmpty(value)) {
                let col = columninfo.find(e => e.columnid === id);
                if (!isEmpty(col)) {
                }
            } else {
                editcode.current = value;
                if (onetomany) {
                    //製品コード（指示No）に対し配色が「多」
                    dispatch(changestatus("NEW FORM"));
                    SetInit();
                } else {
                    //製品コード（指示No）に対し配色が「１」
                    fnc.current.postaxios('colourway/SavedCheck', { "type": id === "d_cw_prodno" ? "0" : "1", "code": value },
                        {
                            onSuccess: function (data) {
                                editcode.current = value;
                                if (!isEmpty(data.request)) {
                                    dispatch(changestatus("ENTRY FORM"));
                                    LoadData(data.request);
                                } else {
                                    dispatch(changestatus("NEW FORM"));
                                    SetInit();
                                }
                            },
                            onError: function (data) {
                                //製品コード/指示番号を元に戻す
                                entrydataRef.current[id] = editcode.current;
                                fnc.current.entryrerender();
                                fnc.current.warnmsg("入力されたコードは存在しません");
                                fnc.current.wait(false);
                            },
                            errmsg: "処理に失敗しました"
                        }
                    )
                }
                function SetInit() {
                    //SKU取得
                    fnc.current.postaxios('colourway/GetProdInfo', { "type": id === "d_cw_prodno" ? "0" : "1", "code": value, "colinfo": columninfo },
                        {
                            onSuccess: function (data) {
                                fnc.current.margeMaster(data.master);
                                data.data[id] = value;
                                Object.assign(entrydataRef.current, data.data);
                                SetProductData(data, true);
                                fnc.current.entryrerender();
                                if (!EmptyPanel(G_id.ROW1)) fnc.current.rerenderGrid(fnc.current.GridID(IdToPanel(G_id.ROW1)));
                                if (!EmptyPanel(G_id.ROW2)) fnc.current.rerenderGrid(fnc.current.GridID(IdToPanel(G_id.ROW2)));
                                if (!EmptyPanel(G_id.ROW3)) fnc.current.rerenderGrid(fnc.current.GridID(IdToPanel(G_id.ROW3)));
                                fnc.current.wait(false);
                            },
                            errmsg: "データが取得できません。削除された可能性があります。"
                        }
                    )
                }
            }
        }
        if (customTarget(corpkey, 'daidoh') && id === "d_cw_attribute5") {
            //ダイドー仕様　生地素材コードからカラー明細を取得
            if (editcode.current === value) return;
            if (!isEmpty(value)) {
                editcode.current = value;
                fnc.current.postaxios('colourway/GetMatlColor', { "code": value },
                    {
                        onSuccess: function (data) {
                            if (data.rowdata.length !== 0) {
                                fnc.current.margeMaster(data.master);
                                let p = {id:G_id.PL, type:"121"};
                                SetGridData(p, data.rowdata);
                                fnc.current.rerenderGrid(fnc.current.GridID(p));
                            }
                            fnc.current.wait(false);
                        },
                    }
                )
            }
        }
        //外部からの参照がある項目
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col)) {
            if (col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }
    }

    function numParser(params) {
        if (!isFinite(params.newValue))
            return '';
        let colinfo = params.data["qtyinfo"];
        if (colinfo === null) return params.newValue;
        let num = Floor(Number(params.newValue), colinfo.decimalplace);
        return num;
    }
    const currencyFormatter = (params) => {
        if (isNaN(params.value)) return '';
        let colinfo = params.data["qtyinfo"];
        if (colinfo === null) return params.value;
        return numformat(params.value, colinfo);

        function numformat(number, colinfo) {
            if (isNaN(number)) return '';
            number = Floor(Number(number), colinfo.decimalplace);
            if (number === 0 && colinfo.format.indexOf('showzero') === -1) {
                return "-";
            }
            if (colinfo.format.indexOf('unuseGrouping') !== -1) return number.toString(); //カンマ区切りなし
            if (colinfo.decimalplace === 0) {
                return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            } else {
                return number.toLocaleString(undefined, {
                    minimumFractionDigits: colinfo.decimalplace,
                    maximumFractionDigits: colinfo.decimalplace
                });
            }
        }
    };

    function SKUQtyAllSet(qty, info) {
        var newdata = DeepCopy(skuqtyRef.current);
        if (newdata.length === 0) return newdata;
        var key = Object.keys(newdata[0]);
        for (let i = 0; i < key.length; i++) {
            if (key[i].indexOf("size_") !== -1) {
                for (let r = 0; r < newdata.length; r++) {
                    newdata[r][key[i]] = qty;
                }
            }
        };
        if (!isEmpty(info)) {
            for (let r = 0; r < newdata.length; r++) {
                newdata[r]["qtyinfo"] = info;
            }
        }
        return newdata;
    }
    //製品コードに対する材料情報およびSKUの表示
    function SetProductData(data, init) {
        let colnoinfo = [{ datatype: CELLTYPE.MASTERCODE, dataid: "m_matl_color_only", keyinfo: "m_matl_color_key=d_cwraw_code", multiple: false, format: '' },
                        { datatype: CELLTYPE.MASTERCODE, dataid: "m_smatl_color_only", keyinfo: "m_smatl_color_key=d_cwraw_code", multiple: false, format: '' },
                        { datatype: CELLTYPE.MASTERCODE, dataid: "d_prod_color_only", keyinfo: "d_prod_color_key=d_cwraw_code", multiple: false, format: '' }]
        let sizeinfo = [{ datatype: CELLTYPE.TEXT },
                        { datatype: CELLTYPE.MASTER, dataid: "m_smatl_size_only", keyinfo: "m_smatl_size_key=d_cwraw_code", dbcolumn: "m_smatl_size_name", multiple: false, format: '', trigger: [] },
                        { datatype: CELLTYPE.MASTER, dataid: "d_prod_size_only", keyinfo: "d_prod_size_key=d_cwraw_code", dbcolumn: "d_prod_size_name", multiple: false, format: '', trigger: [] }]

        for (let i = 0; i < 3; i++) {
            let id = G_id.ROW1;
            if (i === 1) id = G_id.ROW2;
            if (i === 2) id = G_id.ROW3;
            if (EmptyPanel(id)) continue;
            let currentcol = EnsureGridColDef(id);
            if (isEmpty(currentcol)) continue;
            let defcol = currentcol.filter(e => e.field.indexOf("__col") === -1).filter(e => e.field.indexOf("__size") === -1);
            for (let c = 0; c < data.color.length; c++) {
                var colorinfo = DeepCopy(colnoinfo[i]);
                var colno = data.color[c]["d_prod_color_no"];
                colorinfo["columnid"] = "__col" + colno;
                if (i === 0) colorinfo["trigger"] = [{ columnid: "__colnm" + colno, dbcolumn: "m_matl_color_name" }];
                if (i === 1) colorinfo["trigger"] = [{ columnid: "__colnm" + colno, dbcolumn: "m_smatl_color_name" }];
                if (i === 2) colorinfo["trigger"] = [{ columnid: "__colnm" + colno, dbcolumn: "d_prod_color_name" }];
                let column =
                {
                    headerName: data.color[c]["d_prod_color_no"],
                    field: "__col" + colno,
                    colId: "__col" + colno,
                    editable: true,
                    width: 70,
                    cellStyle: { backgroundColor: '#E0E8EF' },
                    colinfo: colorinfo
                }
                defcol.push(column);
                let column2 =
                {
                    headerName: data.color[c]["d_prod_color_name"],
                    field: "__colnm" + colno,
                    colId: "__colnm" + colno,
                    editable: true,
                    width: 100,
                    colinfo: { datatype: CELLTYPE.TEXT, columnid: "__colnm" + colno }
                }
                defcol.push(column2);
            }
            if (i !== 0) {
                for (let s = 0; s < data.size.length; s++) {
                    var size = data.size[s]["d_prod_size_no"];
                    let szinfo = DeepCopy(sizeinfo[i]);
                    szinfo["columnid"] = "__size" + size;
                    let column =
                    {
                        headerName: data.size[s]["d_prod_size_no"] + ":" + data.size[s]["d_prod_size_name"],
                        field: "__size" + size,
                        colId: "__size" + size,
                        editable: true,
                        width: 100,
                        cellStyle: { backgroundColor: 'LemonChiffon' },
                        colinfo: szinfo,
                    }
                    defcol.push(column);
                }
            }
            SetGridColDef(IdToPanel(id), defcol);
        }
        //SKU別数量
        let skuqty = [];
        for (let c = 0; c < data.color.length; c++) {
            let row = { colno: data.color[c]["d_prod_color_no"], colnm: data.color[c]["d_prod_color_name"], rowid: "rowid" + c.toString()};
            for (let s = 0; s < data.size.length; s++) {
                row['size_' + data.size[s]["d_prod_size_no"]] = 0;
            }
            skuqty.push(row);
        }
        skuqtyRef.current = skuqty;
        //明細初期セット
        let show = true;
        if (isEnabled(init) && !initshow) show = false; //明細初期表示なし
        for (let idx = 0; idx < 3; idx++) {
            let id = G_id.ROW1;
            let rowdata = data.raw1;
            if (idx === 1) {
                id = G_id.ROW2; rowdata = data.raw2;
            }
            if (idx === 2) {
                id = G_id.ROW3; rowdata = data.raw3;
            }
            if (EmptyPanel(id)) continue;
            if (isEmpty(rowdata)) rowdata = [];
            if (isEnabled(init) && skuqty.length !== 0) {
                let colinfo = columninfo.find(e => e.logpid === id && e.columnid === "d_cwraw_comqty");
                for (let i = 0; i < rowdata.length; i++) {
                    let cellrec = SKUQtyAllSet(rowdata[i]["d_cwraw_comqty"], colinfo);
                    rowdata[i]["callRecords"] = cellrec;
                }
            }
            if (show) { 
                if (rowdata.length === 0) {
                    SetGridData(IdToPanel(id), [{ rowid: RandomKey() }]);
                } else {
                    SetGridData(IdToPanel(id), rowdata);
                }
            }
        }

        if (masterdetail) {
            var coldefs = [
                { headerName: "C/#", field: 'colno', width: 70, },
                { headerName: "カラー", field: 'colnm', width: 100, },
            ];
            for (let s = 0; s < data.size.length; s++) {
                let sizecol = {
                    headerName: data.size[s]["d_prod_size_no"] + ":" + data.size[s]["d_prod_size_name"], field: 'size_' + data.size[s]["d_prod_size_no"], width: 70,
                    editable: true, cellClass: "ag-right-aligned-cell", valueFormatter: currencyFormatter, valueParser:numParser 
                };
                coldefs.push(sizecol);
            }
            const Params = {
                detailGridOptions: {
                    columnDefs: coldefs,
                    defaultColDef: {
                        sortable: false,
                        filter: false,
                        resizable: true
                    },
                    columnMenu: "legacy",
                    rowSelection: 'multiple',
                    enableRangeSelection: true,
                    suppressMultiRangeSelection: true,
                    enableFillHandle: true,
                    fillHandleDirection: 'xy'
                },
                getDetailRowData: params => {
                    params.successCallback(params.data.callRecords);
                }
            };
            setdetailCellRendererParams(Params);
        }
    }

    function setcollection(kubun) {
        let col = [];
        if (kubun === 0) {  //カラー
            GridApi({ id: G_id.PL, type: "121"}).forEachNode((rowNode, index) => {
                if (col.indexOf(rowNode.data.d_prod_color_no) === -1) {
                    if (!isEmpty(rowNode.data.d_cw_extext1)) {
                        let colnm = "";
                        let mdata = fnc.current.getMaster("m_color", rowNode.data.d_cw_extext1);
                        if (!isEmpty(mdata)) colnm = mdata.m_color_name;
                        col.push({ d_prod_color_no: rowNode.data.d_cw_extext1, d_prod_color_name: colnm });
                    }
                }
            });
        } else {            //サイズ
            GridApi({ id: G_id.PL, type: "120"}).forEachNode((rowNode, index) => {
                if (col.indexOf(rowNode.data.d_prod_size_no) === -1) {
                    if (!isEmpty(rowNode.data.d_cw_extext2)) {
                        col.push({ d_prod_size_no: rowNode.data.d_cw_extext2, d_prod_size_name: '' });
                    }
                }
            });
        }
        return col;
    }
    //ダイドー仕様 カラー/サイズ変更
    function PLChange(param, panel) {
        if(!isEmpty(panel)) storeRowData(panel);
        if (!customTarget(corpkey, 'daidoh')) return;
        var data = {};
        data.color = setcollection(0);
        data.size = setcollection(1);
        if (setcolor.current === JSON.stringify(data.color) && setsize.current === JSON.stringify(data.size)) return;   //変更なし
        data.raw2 = GridData(IdToPanel(G_id.ROW2));
        //製品コードに対する材料情報およびSKUの表示
        SetProductData(data);
        fnc.current.rerenderGrid(fnc.current.GridID(IdToPanel(G_id.ROW2)));
        setcolor.current = JSON.stringify(data.color);
        setsize.current = JSON.stringify(data.size);
    }

    //MasterDetail open/close
    function CellClicked(param, id) {
        if (param.column.colId !== "expand") return;
        param.node.setExpanded(!param.node.expanded);
    }

    //Grid Data Change
    function ChangeRowValue(params,panel) {
        storeRowData(panel);
        let id = panel.id;
        let rowidx = params.node.rowIndex;
        if (!ExistDetail(params.node.data)) {
            if (skuqtyRef.current === null) return;
            let rowdata = DeepCopy(GridData(IdToPanel(id))[rowidx]);
            let colinfo = columninfo.find(e => e.logpid === id && e.columnid === "d_cwraw_comqty");
            let newdata = SKUQtyAllSet(0, colinfo);
            rowdata["callRecords"] = newdata;
            const tran = {
                update: [rowdata],
            };
            params.api.applyTransaction(tran);
            return;
        }
        if (params.column.colId === "d_cwraw_code") {
            //配色C/#、サイズクリア
            for (let i = 0; i < GridColDef(IdToPanel(id)).length; i++) {
                let columnid = GridColDef(IdToPanel(id))[i].colId;
                if (columnid.indexOf("__col") !== -1 || columnid.indexOf("__size") !== -1) {
                    GridData(IdToPanel(id))[rowidx][columnid] = "";
                }
            }
            var node = GridApi(IdToPanel(id)).getDisplayedRowAtIndex(rowidx);
            if (!isEmpty(node)) {
                node.setData(GridData(IdToPanel(id))[rowidx]);
            }

        }
        if (params.column.colId === "d_cwraw_comqty") {
            if (!ExistDetail(params.node.data)) return;
            let rowdata = DeepCopy(params.node.data);
            let newdata = SKUQtyAllSet(params.value, rowdata["callRecords"][0]["qtyinfo"]);
            rowdata["callRecords"] = newdata;
            const tran = {
                update: [rowdata],
            };
            params.api.applyTransaction(tran);
        }
        if (params.column.colId === "d_cwraw_amount" || params.column.colId === "d_cwraw_arrange" || params.column.colId === "d_cwraw_fcamount") {
            RowDataChanged(id);
        }
        if (customTarget(corpkey, 'daidoh')) {
            if (params.column.colId === "d_cwraw_amount2" || params.column.colId === "d_cwraw_fcamount2" ||
                params.column.colId === "d_cwraw_amount3" || params.column.colId === "d_cwraw_fcamount3" ||
                params.column.colId === "d_cwraw_amount4" || params.column.colId === "d_cwraw_fcamount4" ) {
                RowDataChanged(id);
            }
        }
    }
    function RowValueChanged(colid, targets, id) {
        for (let i = 0; i < targets.length; i++) {
            if (!ExistDetail(targets[i])) {
                //新規行
                if (skuqtyRef.current === null) return;
                let colinfo = columninfo.find(e => e.logpid === id && e.columnid === "d_cwraw_comqty");
                let qty = DicVal(targets[i], "d_cwraw_comqty",0);
                let newdata = SKUQtyAllSet(qty, colinfo);
                targets[i]["callRecords"] = newdata;
                const tran = {
                    update: [targets[i]],
                };
                GridApi(IdToPanel(id)).applyTransaction(tran);
            } else {
                if (colid === "d_cwraw_code") {
                    //配色C/#、サイズクリア
                    for (let c = 0; c < GridColDef(IdToPanel(id)).length; c++) {
                        let columnid = GridColDef(IdToPanel(id))[c].colId;
                        if (columnid.indexOf("__col") !== -1 || columnid.indexOf("__size") !== -1) {
                            targets[i][columnid] = "";
                        }
                    }
                    var node = GridApi(IdToPanel(id)).getRowNode(targets[i].rowid);
                    if (!isEmpty(node)) {
                        node.setData(targets[i]);
                    }
                }
            }
        }
        RowDataChanged(id);
    }
    //Grid Row Data Change
    function RowDataChanged(id) {
        if (EmptyPanel("T" + id)) return;   //合計なし
        if (customTarget(corpkey, 'daidoh')) {
            SetTotal(id);
            fnc.current.rerenderGrid(fnc.current.GridID(IdToPanel("T" + id)));
            return;
        }
        let idx = id - 1;
        let total = 0;
        let amount = 0;
        let fctotal = 0;
        let fcamount = 0;
        let data = GridData(IdToPanel(id));
        for (let i = 0; i < data.length; i++) {
            total += NumConv(DicVal(data[i], "d_cwraw_amount", 0));
            if (DicVal(data[i], "d_cwraw_arrange", "0") === "1") {
                amount += NumConv(DicVal(data[i], "d_cwraw_amount", 0));
            }
            fctotal += NumConv(DicVal(data[i], "d_cwraw_fcamount", 0));
            if (DicVal(data[i], "d_cwraw_arrange", "0") === "1") {
                fcamount += NumConv(DicVal(data[i], "d_cwraw_fcamount", 0));
            }
        }
        let p = IdToPanel("T" + id);
        GridData(p)[0]["d_cw_amtrawo" + (idx + 1).toString()] = Round(total - amount, 2);
        GridData(p)[0]["d_cw_amtrawy" + (idx + 1).toString()] = Round(amount, 2);
        GridData(p)[0]["d_cw_total" + (idx + 1).toString()] = Round(total, 2);
        GridData(p)[0]["d_cw_fcamtrawo" + (idx + 1).toString()] = Round(fctotal - fcamount, 2);
        GridData(p)[0]["d_cw_fcamtrawy" + (idx + 1).toString()] = Round(fcamount, 2);
        GridData(p)[0]["d_cw_fctotal" + (idx + 1).toString()] = Round(fctotal, 2);
        let rowNode = GridApi(p).getRowNode("TOTAL");
        if (!isEmpty(rowNode)) rowNode.setData(GridData(p)[0]);
    }
    //ダイドー仕様 合計表示
    function SetTotal(id) {
        let amount = ["d_cwraw_amount", "d_cwraw_amount2", "d_cwraw_amount3", "d_cwraw_amount4"];
        let fcamount = ["d_cwraw_fcamount", "d_cwraw_fcamount2", "d_cwraw_fcamount3", "d_cwraw_fcamount4"];
        let p = IdToPanel("T" + id);
        let total = GridData(p);
        let data = GridData(IdToPanel(id));
        if (isEmpty(data)) return;
        for (let r = 0; r < 4; r++) {
            let t = { total: 0, amount : 0, fctotal : 0, fcamount : 0 };
            for (let i = 0; i < data.length; i++) {
                t.total += NumConv(DicVal(data[i], amount[r], 0));
                if (DicVal(data[i], "d_cwraw_arrange", "0") === "1") {
                    t.amount += NumConv(DicVal(data[i], amount[r], 0));
                }
                t.fctotal += NumConv(DicVal(data[i], fcamount[r], 0));
                if (DicVal(data[i], "d_cwraw_arrange", "0") === "1") {
                    t.fcamount += NumConv(DicVal(data[i], fcamount[r], 0));
                }
            }
            total[r]["d_cw_amtrawo2"] = Round(t.total - t.amount, 2);
            total[r]["d_cw_amtrawy2"] = Round(t.amount, 2);
            total[r]["d_cw_total2"] = Round(t.total, 2);
            total[r]["d_cw_fcamtrawo2"] = Round(t.fctotal - t.fcamount, 2);
            total[r]["d_cw_fcamtrawy2"] = Round(t.fcamount, 2);
            total[r]["d_cw_fctotal2"] = Round(t.fctotal, 2);
        }
        SetGridData(p, total);
    }
    function ExistDetail(data) {
        if ("callRecords" in data === false) return false;
        if (data["callRecords"].length === 0) return false;
        return true;
    }
    function ididx(id) {
        switch (id) {
            case G_id.ROW1: return 0;
            case G_id.ROW2: return 1;
            case G_id.ROW3: return 2;
            default: return 0;
        }
    }
    //ダイドー仕様
    function showcellchange(type) {
        var cells = [];
        if (type === 0) {
            //用尺
            cells = ['d_cwraw_comqty', 'd_cwraw_comqty2', 'd_cwraw_comqty3', 'd_cwraw_comqty4'];
        } else {
            //金額
            cells = ['d_cwraw_amount', 'd_cwraw_amount2', 'd_cwraw_amount3', 'd_cwraw_amount4', 'd_cwraw_fcamount', 'd_cwraw_fcamount2', 'd_cwraw_fcamount3', 'd_cwraw_fcamount4'];
        }
        var visible = GridColApi(IdToPanel(G_id.ROW2)).getColumn(cells[0]).isVisible();
        GridColApi(IdToPanel(G_id.ROW2)).setColumnsVisible(cells, !visible);
    }

    function EmptyPanel(id, type) {
        try {
            return isEmpty(columns.find(e => e.logpid === id));
        } catch { return false; }
    }


    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }
    //パネルセレクタ
    function panelnavwidth() {
        return windowDimensions.width - 280;
    }

    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.abbr}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} disabled={layoutlock}/>
                ))}
            </ul>
        );
    });
    function Contents(props) {
        if (props.panel.id === G_id.BASE) {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} >
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.grid) {
            if (props.panel.id !== G_id.PL) {
                return (
                    <React.Fragment>
                    <EntryGridAr
                        id={fnc.current.GridID(props.panel)}
                        masterDetail={masterdetail}
                        detailCellRendererParams={detailCellRendererParams}
                        entrydataRef={entrydataRef}
                        dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                        columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                        columninfo={columninfo}
                        columns={columns}
                        sortable={true}
                        fnc={fnc}
                        onFirstDataRendered={onFirstDataRendered}
                        formid={formid}
                        ValueChanged={(e) => ChangeRowValue(e, props.panel)}
                        RowValueChanged={(colid, targets) => RowValueChanged(colid, targets, props.panel.id)}
                        RemoveRow={(e) => RowDataChanged(props.panel.id)}
                        CellClicked={(e) => CellClicked(e, props.panel.id)}
                        panel={props.panel}
                    />
                        {EmptyPanel("T" + props.panel.id) ? null :
                        <EntryGridAr
                            id={fnc.current.GridID(IdToPanel("T" + props.panel.id))}
                            entrydataRef={entrydataRef}
                            dataRef={griddataRefs.current[fnc.current.gridindex(IdToPanel("T" + props.panel.id))]}
                            columnRef={gridcolRefs.current[fnc.current.gridindex(IdToPanel("T" + props.panel.id))]}
                            columninfo={columninfo}
                            columns={columns}
                            fnc={fnc}
                            onFirstDataRendered={onFirstDataRendered}
                            formid={formid}
                            total={true}
                            panel={props.panel}
                        />
                    }
                    </React.Fragment>
                );
            } else {
                return (
                    <EntryGridAr
                        id={fnc.current.GridID(props.panel)}
                        entrydataRef={entrydataRef}
                        dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                        columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                        columninfo={columninfo}
                        columns={columns}
                        fnc={fnc}
                        onFirstDataRendered={onFirstDataRendered}
                        formid={formid}
                        ValueChanged={(e) => PLChange(e, props.panel)}
                        RowValueChanged={(e) => PLChange(e, props.panel)}
                        RemoveRow={(e) => PLChange(e, props.panel)}
                        SwapRow={(e) => PLChange(e, props.panel)}
                        panel={props.panel}
                    />
                );
            }
        }

        return null;

    }
    function maximizeChanged(id, max) {
        const newvalue = JSON.parse(JSON.stringify(GridPanelRef.current));
        newvalue[id] = max;
        GridPanelRef.current = newvalue;
        //ストレージに保存
        Savestorage(corpkey, account, GridPanelStorageKey, GridPanelRef.current);
    }

    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', paddingBottom: '300px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef}>
                {panel.map((p, i) => {
                    return (
                        <Box
                            display={panelhidden(p) ? "none" : "flex"}
                            justifyContent="space-around"
                            alignItems="center"
                            padding="5px"
                        >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10
                                }}
                            >
                                <div style={{ position: 'relative', marginBottom: 10 }}>
                                    {p.name === '' ? <div style={{ display: 'inline-block', height: 10 }}></div> : p.name}
                                    {p.name2 !== '' ? '-': ''}
                                    <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                    {p.id === G_id.ROW2 && customTarget(corpkey, 'daidoh') ?
                                        <div style={{ position: 'absolute', left: 100, top: -5 }}>
                                            <Button size="small" onClick={() => showcellchange(0)}
                                                style={{
                                                    width: 100, backgroundColor: "#BABBAB", color: '#FFF', fontWeight: 700, marginRight: 20
                                                }}
                                            >
                                                用尺表示切替
                                            </Button>
                                            <Button size="small" onClick={() => showcellchange(1)}
                                                style={{
                                                    width: 100, backgroundColor: "#BABBAB", color: '#FFF', fontWeight: 700, marginRight: 50
                                                }}
                                            >
                                                金額表示切替
                                            </Button>
                                        </div>
                                        :null
                                    }
                                    {p.id !== '0' || layoutlock ? null :
                                        <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                            <IconButton size="small" onClick={() => SetBaseField(p.type)}  >
                                                <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                    {!p.grid ? null :
                                        <div style={{ position: 'absolute', right: 40, top: -3 }}>
                                            <GridPanelControl id={fnc.current.GridID(p)} fnc={fnc} gridmaximize={GridPanelRef} ValueChanged={maximizeChanged} />
                                        </div>
                                    }
                                    {layoutlock || sectionclose ? null :
                                        <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                            <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                                <Icon style={{ fontSize: 16 }}>close</Icon>
                                            </IconButton>
                                        </div>
                                    }
                               </div>
                                <Contents panel={p} />
                            </Paper >
                        </Box>
                    );
                })}
            </div>
        );
    }

    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                entrycallback={MenuAction}
                queryaction={MenuQueryAction}
                condition={true}
                entryform={true}
                tabs={true}
                show={Show}
                primaryid={'d_colourway'}
                primarykey={primarykeys}
                parentedit={true}
                navmenu={formlock ? navmenu.filter(e => e.menuid !== 'formupload') : navmenu}
                suppressaction={suppressaction}
                lockcell={ListlockCell}
                slipsave={true}
            >
                <EntryForm />
            </MasterBase>
            <EntryLayout
                columninfo={textfieldsall}
                textfields={textfields}
                onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <Headline columninfo={columninfo} entrydata={entrydataRef.current} ></Headline>
                    <div style={{ position: 'absolute', top: 60, left: 210 }}>
                        <Paper
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexWrap: 'wrap',
                                listStyle: 'none',
                                p: 0.2,
                                m: 0,
                            }}
                            component="ul"
                            elevation={0}
                            style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                        >
                            {/*Panel Selector*/}
                            <SortablePanelSelector
                                axis={"x"}
                                items={panel}
                                onSortEnd={onPanelSortEnd}
                                distance={2}
                            />
                        </Paper>
                    </div>
                </div>
                : null}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
            <DataTree code={edittingcode} />
        </div>
    );
};
